// No more container, fix everything that imports it.
import MainTemplate from './MainTemplate';

export default MainTemplate;
